import React from 'react'

type AppErrorBoundaryState = {
  hasError: boolean
  errorMessage: string
}

class AppErrorBoundary extends React.Component<React.PropsWithChildren, AppErrorBoundaryState> {
  state: AppErrorBoundaryState = {
    hasError: false,
    errorMessage: ''
  }

  static getDerivedStateFromError(error: Error): AppErrorBoundaryState {
    return {
      hasError: true,
      errorMessage: error.message || 'Unknown runtime error'
    }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('App runtime crash captured by error boundary:', error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh',
          background: '#111827',
          color: '#fff',
          padding: '2rem',
          fontFamily: 'Inter, sans-serif'
        }}>
          <h1 style={{ marginBottom: '1rem' }}>Booking System Runtime Error</h1>
          <p style={{ marginBottom: '1rem' }}>A client-side crash prevented rendering.</p>
          <pre style={{
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
            background: '#1f2937',
            padding: '1rem',
            borderRadius: '8px',
            border: '1px solid #374151'
          }}>
            {this.state.errorMessage}
          </pre>
          <button
            onClick={() => window.location.reload()}
            style={{
              marginTop: '1rem',
              background: '#0891b2',
              color: '#fff',
              border: 'none',
              borderRadius: '8px',
              padding: '0.75rem 1rem',
              cursor: 'pointer'
            }}
          >
            Reload Page
          </button>
        </div>
      )
    }

    return this.props.children
  }
}

export default AppErrorBoundary
